// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","195":"5f7fd88b611eb32b310b","243":"307c1cf31df043fbcfea","595":"f7776ac79a7da92f941a","658":"f3a87b5cabfad04c0b8f","871":"0fa273f54867fb6bfb66"}[chunkId] + ".bundle.js";
};